module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IR-083ef1ddcd17c823c2d57a6ef2c8e9b6.png";